/* ==========================================================================
   ROOM3D — 3D theme config for the 11 salon rooms.
   Faithful to the original room palettes/frames/eggs, translated to 3D.
   ========================================================================== */
/* 2026-10-29: MLow asked for the Scottish castle as the first room; the rest of the loop keeps its order. */
window.ROOM_ORDER = ['castle','garden','forest','zen','ryokan','paris','florence','santorini','miami','desert','bauhaus','brooklyn','arcade','thai','morocco','cathedral','opera','aurora','space','infinity','underwater'];

window.ROOM3D = {
  zen:{
    name:'Kyoto Zen Garden', frame:'black', mat:'light', egg:'Karate Kid · "wax on, wax off"',
    icon:'🪨', eggKind:'rock', note:[392,0.5,'sine'], scene:'shoji',
    wall:'#e9efe6', wainscot:'#dfe7dd', floor:'#d8c79e', floorKind:'tatami', ceiling:'#f2f5ef',
    ambient:['#e2efe4',0.85], key:['#fff3da',0.9], accent:'#3f8f8c',
    fog:['#dde8df',0.009], bright:true
  },
  ryokan:{
    name:'Japanese Ryokan', frame:'black', mat:'light', egg:'Totoro · catch the soot sprites',
    icon:'🐾', eggKind:'totoro', note:[329.63,0.7,'sine'], scene:'shoji', lantern:1,
    wall:'#ece4d4', wainscot:'#d8c6a6', floor:'#7a5836', floorKind:'wood', ceiling:'#efe7d6',
    ambient:['#efe6d2',0.8], key:['#ffe9bf',0.95], accent:'#8a6840',
    fog:['#e3d8c2',0.01], bright:true
  },
  paris:{
    name:'Parisian Apartment', frame:'gold', mat:'light', egg:'Amélie · the garden gnome',
    icon:'🍄', eggKind:'gnome', note:[349.23,0.4,'sine'], scene:'casement',
    wall:'#ece9e1', wainscot:'#dcd7c9', floor:'#b08a55', floorKind:'parquet', ceiling:'#f5f3ec',
    ambient:['#efece3',0.82], key:['#fff0d2',0.95], accent:'#9c4140',
    fog:['#e7e3d8',0.009], bright:true
  },
  santorini:{
    name:'Santorini Sunset', frame:'white', mat:'light', egg:'Mamma Mia · here we go again',
    icon:'⛪', eggKind:'dome', note:[293.66,0.5,'sine'], scene:'santorini',
    wall:'#f3ede4', wainscot:'#e7dccb', floor:'#e8e0d2', floorKind:'stone', ceiling:'#f6efe2',
    ambient:['#ffd9b0',0.8], key:['#ff9d5c',1.15], accent:'#2f6fb0',
    fog:['#f0c79a',0.011], bright:true, sky:['#e8765f','#ffce72']
  },
  miami:{
    name:'Miami Poolside', frame:'white', mat:'light', egg:'Scarface · say hello…',
    icon:'🦩', eggKind:'flamingo', note:[293.66,0.3,'sine'], scene:'miami', palms:true,
    wall:'#fbeef0', wainscot:'#ffd9e2', floor:'#e9eef0', floorKind:'deco', ceiling:'#eafaff',
    ambient:['#d8f4ff',0.85], key:['#fff0e2',1.05], accent:'#ff5d8f',
    fog:['#cfeefb',0.009], bright:true, sky:['#7fd8f0','#ffd1e0']
  },
  thai:{
    name:'Thai Palace', frame:'gold', mat:'dark', egg:'The King and I · shall we dance',
    icon:'🙏', eggKind:'buddha', note:[329.63,0.6,'sine'], scene:'thai', columns:true,
    wall:'#2a1c44', wainscot:'#3a2150', floor:'#241433', floorKind:'marble', ceiling:'#1b1030',
    ambient:['#3a2452',0.5], key:['#ffd27a',0.95], accent:'#d9a23f',
    fog:['#1c1130',0.03], bright:false
  },
  morocco:{
    name:'Moroccan Blue', frame:'gold', mat:'dark', egg:'Aladdin · rub the lamp',
    icon:'🪔', eggKind:'lamp', note:[493.88,0.6,'sine'], scene:'morocco', lantern:2, rug:true,
    wall:'#0b3346', wainscot:'#0f4258', floor:'#072430', floorKind:'zellige', ceiling:'#08293a',
    ambient:['#0f4a60',0.55], key:['#ffd98a',0.95], accent:'#c9a24a',
    fog:['#07212e',0.03], bright:false
  },
  opera:{
    name:'Grand Opera Hall', frame:'gold', mat:'dark', egg:'Phantom of the Opera · the mask',
    icon:'🎭', eggKind:'mask', note:[261.63,0.9,'sawtooth'], scene:'opera', curtains:true, chandelier:true, piano:true,
    wall:'#3a0c18', wainscot:'#52101f', floor:'#1f0a10', floorKind:'velvet', ceiling:'#1a0408',
    ambient:['#430f1c',0.5], key:['#ffcaa0',1.0], accent:'#d4a843',
    fog:['#1a0408',0.032], bright:false
  },
  space:{
    name:'Space Station', frame:'black', mat:'dark', egg:'2001 · open the pod bay doors, HAL',
    icon:'🔴', eggKind:'hal', note:[110,1.1,'sine'], scene:'space',
    wall:'#11142b', wainscot:'#1a1f3e', floor:'#0a0c1a', floorKind:'metal', ceiling:'#0c0e1f',
    ambient:['#1b2147',0.55], key:['#cfe0ff',1.0], accent:'#e0162b',
    fog:['#06060f',0.028], bright:false, stars:true
  },
  infinity:{
    name:'Infinity Void', frame:'neon', mat:'dark', egg:'Kusama · the polka dots',
    icon:'⚫', eggKind:'dots', note:[523.25,0.4,'triangle'], scene:'infinity',
    wall:'#080810', wainscot:'#0c0c18', floor:'#050509', floorKind:'mirror', ceiling:'#050507',
    ambient:['#101028',0.4], key:['#00e5ff',0.7], accent:'#00e5ff',
    fog:['#050507',0.026], bright:false, stars:true
  },
  underwater:{
    name:'Underwater', frame:'black', mat:'dark', egg:'Finding Nemo · just keep swimming',
    icon:'🐠', eggKind:'nemo', note:[329.63,0.4,'sine'], scene:'underwater', fish:true, bubbles:true,
    wall:'#0a4a72', wainscot:'#0c537f', floor:'#062f50', floorKind:'caustic', ceiling:'#063a60',
    ambient:['#0e5680',0.6], key:['#bfe8ff',0.95], accent:'#ff6f91',
    fog:['#063a60',0.045], bright:false, caustics:true
  },

  /* ===================== 10 NEW ROOMS ===================== */
  garden:{
    name:'Flower Garden', frame:'white', mat:'light', egg:'Alice in Wonderland · follow it',
    icon:'🦋', eggKind:'butterfly', note:[523.25,0.4,'sine'], scene:'garden', flowers:true, pergola:true,
    wall:'#cdbf9a', wainscot:'#bdae87', floor:'#7f9a55', floorKind:'moss', ceiling:'#bfe3ff',
    ambient:['#dff0ff',0.9], key:['#fff6e0',1.0], accent:'#ff5a8a',
    fog:['#dff0e8',0.008], bright:true, openCeiling:true
  },
  forest:{
    name:'Enchanted Forest', frame:'black', mat:'dark', egg:'Princess Mononoke · the kodama',
    icon:'🍄', eggKind:'spirit', note:[329.63,0.5,'sine'], scene:'forest', trees:true, fireflies:true,
    wall:'#1a3a24', wainscot:'#2a5a32', floor:'#1f3a1a', floorKind:'moss', ceiling:'#0a2a16',
    ambient:['#1f4a2a',0.55], key:['#cfffb0',0.9], accent:'#dfff8a',
    fog:['#0a2414',0.04], bright:false
  },
  florence:{
    name:'Florence Casa', frame:'gold', mat:'dark', egg:'Michelangelo · the David',
    icon:'🗿', eggKind:'david', note:[440,0.5,'sine'], scene:'florence', sconces:2, statue:true,
    wall:'#cdb088', wainscot:'#8f6a40', floor:'#9c6a3e', floorKind:'flagstone', ceiling:'#b9966c',
    ambient:['#e3cfb0',0.8], key:['#ffe6b8',1.0], accent:'#c9a86f',
    fog:['#cdb088',0.012], bright:true
  },
  desert:{
    name:'Desert Modernist', frame:'white', mat:'light', egg:'Looney Tunes · meep meep',
    icon:'🌵', eggKind:'cactus', note:[523.25,0.1,'square'], scene:'desert', cacti:true, bench:true,
    wall:'#efe3d4', wainscot:'#d8c3a6', floor:'#cdb89a', floorKind:'concrete', ceiling:'#f2ead8',
    ambient:['#f5ead8',0.88], key:['#fff0d8',1.05], accent:'#c98a4e',
    fog:['#f0d9bf',0.008], bright:true
  },
  bauhaus:{
    name:'Bauhaus Gallery', frame:'black', mat:'light', egg:'Mondrian · composition complete',
    icon:'⬛', eggKind:'mondrian', note:[261.63,0.5,'square'], scene:'bauhaus', blocks:true,
    wall:'#f4f1ea', wainscot:'#d8d2c6', floor:'#c8c2b4', floorKind:'concrete', ceiling:'#ffffff',
    ambient:['#ffffff',0.95], key:['#ffffff',1.0], accent:'#2962ff',
    fog:['#f2efe9',0.006], bright:true
  },
  brooklyn:{
    name:'Brooklyn High-Rise', frame:'black', mat:'dark', egg:'Back to the Future · 88 mph',
    icon:'🚕', eggKind:'taxi', note:[392,0.18,'square'], scene:'brooklyn', skyline:true, taxi:true,
    wall:'#20242f', wainscot:'#15171f', floor:'#2b2f3a', floorKind:'plank', ceiling:'#15171f',
    ambient:['#2a2f45',0.6], key:['#ffd9a8',1.0], accent:'#f2a45c',
    fog:['#10131c',0.022], bright:false
  },
  arcade:{
    name:'Cyberpunk Arcade', frame:'neon', mat:'dark', egg:'The Matrix · code rain',
    icon:'🕹️', eggKind:'slot', note:[329.63,0.1,'square'], scene:'arcade', cabinets:true, neon:true, gridfloor:true,
    wall:'#1a0a2e', wainscot:'#2a0a4a', floor:'#10031f', floorKind:'grid', ceiling:'#0a0418',
    ambient:['#2a0a4a',0.5], key:['#00e5ff',0.8], accent:'#ff2e63',
    fog:['#0a0418',0.03], bright:false, stars:false
  },
  castle:{
    name:'Scottish Castle', frame:'black', mat:'dark', egg:'Braveheart · FREEDOM',
    icon:'🛡️', eggKind:'banner', note:[261.63,0.9,'sawtooth'], scene:'castle', torches:true, hearth:true, banners:true,
    wall:'#4a5159', wainscot:'#3a4149', floor:'#3a4149', floorKind:'flagstone', ceiling:'#2a3038',
    ambient:['#3a4250',0.5], key:['#ffce8a',0.9], accent:'#e8bf4a',
    fog:['#222831',0.03], bright:false
  },
  cathedral:{
    name:'Gothic Cathedral', frame:'gold', mat:'dark', egg:'Hunchback of Notre-Dame · the bells',
    icon:'🔔', eggKind:'rose', note:[261.63,0.9,'sine'], scene:'cathedral', columns:true, candles:true, vaulted:true,
    wall:'#1a1a2a', wainscot:'#2a2a3a', floor:'#1a1a24', floorKind:'flagstone', ceiling:'#0a0a14',
    ambient:['#1a1a2e',0.5], key:['#cfd6ff',0.95], accent:'#9b5fff',
    fog:['#0a0a14',0.03], bright:false, vaulted:true
  },
  aurora:{
    name:'Aurora Cabin', frame:'black', mat:'dark', egg:'Frozen · let it go',
    icon:'❄️', eggKind:'snow', note:[523.25,0.7,'sine'], scene:'aurora', fireplace:true, aurora:true, beams:true,
    wall:'#2a1d12', wainscot:'#3a2c20', floor:'#3a2c20', floorKind:'plank', ceiling:'#1a120c',
    ambient:['#1a2a40',0.55], key:['#bfe8ff',0.85], accent:'#3fffb0',
    fog:['#04101f',0.028], bright:false, stars:true
  }
};

/* ===================== v2: LAYOUT + SKY per room ===================== */
/* layout: 'hall' (corridor) | 'wide' (broad gallery) | 'square' (4-wall salon) | 'rotunda' (circular)
   sky: 'day' | 'sunset' | 'night' | 'dusk' | 'none'   openCeiling: see the sky directly */
(function(){
  const L={
    garden:    {layout:'square',  sky:'day',    openCeiling:true},
    forest:    {layout:'rotunda', sky:'night',  openCeiling:true},
    zen:       {layout:'hall',    sky:'day',    openCeiling:false},
    ryokan:    {layout:'wide',    sky:'dusk',   openCeiling:false},
    paris:     {layout:'hall',    sky:'day',    openCeiling:false},
    florence:  {layout:'square',  sky:'day',    openCeiling:false},
    santorini: {layout:'wide',    sky:'sunset', openCeiling:true},
    miami:     {layout:'square',  sky:'sunset', openCeiling:true},
    desert:    {layout:'wide',    sky:'day',    openCeiling:true},
    bauhaus:   {layout:'square',  sky:'day',    openCeiling:false},
    brooklyn:  {layout:'wide',    sky:'sunset', openCeiling:false},
    arcade:    {layout:'square',  sky:'night',  openCeiling:false},
    thai:      {layout:'hall',    sky:'dusk',   openCeiling:false},
    morocco:   {layout:'hall',    sky:'night',  openCeiling:false},
    castle:    {layout:'hall',    sky:'night',  openCeiling:false},
    cathedral: {layout:'rotunda', sky:'night',  openCeiling:true},
    opera:     {layout:'hall',    sky:'night',  openCeiling:false},
    aurora:    {layout:'wide',    sky:'night',  openCeiling:true},
    space:     {layout:'rotunda', sky:'night',  openCeiling:true},
    infinity:  {layout:'rotunda', sky:'night',  openCeiling:false},
    underwater:{layout:'hall',    sky:'none',   openCeiling:false}
  };
  for(const id in L){ if(window.ROOM3D[id]) Object.assign(window.ROOM3D[id], L[id]); }
})();
/* ========================================================================
   THE VAULT — drop venue. The next work sleeps here until the window opens.
   Appears locked in the room list; drop-vault.js drives the overlay.
   ======================================================================== */
window.ROOM_ORDER.push('vault');
window.ROOM3D.vault = {
  name:'The Vault', frame:'neon', mat:'dark', egg:'The next drop sleeps here',
  icon:'🔒', eggKind:'rock', note:[196,0.5,'sine'], scene:'infinity',
  wall:'#0d1020', wainscot:'#141a33', floor:'#0a0c18', floorKind:'marble', ceiling:'#05060d',
  ambient:['#1a2340',0.75], key:['#2962FF',0.85], accent:'#2962FF',
  fog:['#05060d',0.012], layout:'hall', sky:'night', openCeiling:false
};
